export default __webpack_public_path__ + "static/media/evaluators.3322f808.svg";